import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class StatusPedidoClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async findAll(params = {}) {
    try {
      const { data } = await this.api.get('/status-pedido/findAll', { params });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar dados do relatório de status de pedidos');
    }
  }
}
